<template>
    <div class="step">
        <div class="row">
            <div class="col-md-6">
                <div class="form-group row align-items-center mb-0">
                    <label for="as_of" class="col-lg-6">{{ $t('titles.as_of') }}</label>
                    <div class="col-lg-6">
                        <div class="input-group datepicker-group">
                            <input v-if="outOfLimit" id="as_of" type="text" name="as_of" v-model="asOf"
                                   class="datepicker w-100">
                            <input v-else id="as_of" type="text" name="as_of" v-model="asOf" class="datepicker w-100 err"
                                   required="required">
                            <i class="fas fa-calendar"></i>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
export default {
    name: "step-date",

    props: ['date-limit'],

    data: function () {
        return {
            asOf: null
        }
    },

    mounted: function () {
        if (!this.$parent.oldData.as_of) {
            this.asOf = this.formatDate()
        } else {
            this.asOf = this.$parent.oldData.as_of
        }
    },

    methods: {
        formatDate: function (date) {
            date = (typeof date !== 'undefined') ?  date : new Date()

            let dd = date.getDate()
            let mm = date.getMonth() + 1
            let yyyy = date.getFullYear()

            if (dd < 10) { dd = '0' + dd }
            if (mm < 10) { mm = '0' + mm }

            return dd + '.' + mm + '.' + yyyy
        },

        isoDate: function (date) {
            let arrDate = []

            try {
                arrDate = date.split('.')
            } catch(error) {}

            arrDate[0] = parseInt(arrDate[0])
            arrDate[0] = arrDate[0] < 10 ? '0' + arrDate[0] : arrDate[0]

            arrDate[1] = parseInt(arrDate[1])
            arrDate[1] = arrDate[1] < 10 ? '0' + arrDate[1] : arrDate[1]

            if (arrDate.length === 3) {
                return arrDate[2] + '-' + arrDate[1] + '-' + arrDate[0]
            }

            return null
        }
    },

    computed: {
        outOfLimit: function () {
            let limitDate = this.$parent.minDates[this.$parent.type == 'land' ? 'land' : 'default']

            let limit = new Date(this.isoDate(limitDate))
            let value = new Date(this.isoDate(this.asOf))
            let today = new Date()

            let input = document.getElementById('as_of')
            if (value > today) {
                if (input) {
                    input.setCustomValidity('Odhad k budoucímu datu ještě neumíme ;)')
                }

                return false
            }

            if (limit > value) {
                if (input) {
                    input.setCustomValidity('Odhad pro tento typ nemovitosti musí být nejdříve k datu po ' + limitDate)
                }
            } else {
                if (input) {
                    input.setCustomValidity('')
                }
            }

            return limit <= value
        },
    }
}
</script>

<style scoped>
    .err {
        outline: red;
        border: 1px solid red !important;
    }
</style>
